<br>
<!-- <div class="panel-heading" style="color:#ffffff;background-color: #032041;" title="PROJECT DOCUMENTS">
  <div class="page-title">
    PROJECT DOCUMENTS
  </div>
</div>

<div class="mat-elevation-z8">
  <mat-table [dataSource]="DocsdataSource" matSort>
    <ng-container matColumnDef="DocumentName">
      <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0 aria-label="Document Name">
        <label id="DocumentName" aria-label="Document Name">Document Name</label>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" tabindex="0" style="width: 100%;">
        <span class="mobile-label" style="min-width: 150px"><label aria-label="Document Name">Document
            Name:</label></span>
        <div title="{{element.DocumentName}} " class="displaynormal column-overflow">{{element.DocumentName}}</div>
        <div title="{{element.DocumentName}} " class="displaysmall" style="display: none;">{{element.DocumentName}}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="FileName">
      <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0 aria-label="File Name">
        <label id="FileName" aria-label="Street Name">File Name</label>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" tabindex="0" style="width: 100%;">
        <span class="mobile-label" style="min-width: 150px"><label aria-label="File Name">File Name:
          </label></span>
        <div class="displaynormal column-overflow" title="{{element.FileName}} ">{{element.FileName}}</div>
        <div class="displaysmall" style="display: none;" title="{{element.FileName}} ">{{element.FileName}}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="DocumentAuthor">
      <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0 aria-label="Document Author">
        <label id="DocumentAuthor" aria-label="Document Author">Document Author</label>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" tabindex="0" style="width: 100%;">
        <span class="mobile-label" style="min-width: 150px"><label aria-label="Document Author">Document Author:
          </label></span>
        <div class="displaynormal column-overflow" title="{{element.DocumentAuthor}} ">{{element.DocumentAuthor}}
        </div>
        <div class="displaysmall" style="display: none;" title="{{element.DocumentAuthor}} ">
          {{element.DocumentAuthor}}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PublicAccess">
      <mat-header-cell *matHeaderCellDef mat-sort-header tabindex=0 aria-label="Public Access">
        <label id="PublicAccess" aria-label="Public Access">Public Access</label>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" tabindex="0" style="width: 100%;">
        <span class="mobile-label" style="min-width: 150px"><label aria-label="Public Access">Public Access:
          </label></span>
        <div class="displaynormal column-overflow" title="{{element.PublicAccess === true ? 'Yes' : 'No'}}">
          {{element.PublicAccess === true ? 'Yes' : 'No'}}</div>
        <div class="displaysmall" style="display: none;" title="{{element.PublicAccess === true ? 'Yes' : 'No'}}">
          {{element.PublicAccess === true ? 'Yes' : 'No'}}
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="View">
      <mat-header-cell *matHeaderCellDef> View Document</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <span class="mobile-label">View Document:</span>
        <img style="cursor: pointer; color: #fff;" title="View" (click)="downloadfile(element);" tabindex="0"
          src="../assets/images/icon_viewnewadam.png">
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
</div> -->

<div class="row"
  style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;">
  <div class="td-col-md-2" style="width: 20%; padding-left: 20px;" class="mobileview"></div>
  <div class="card mobileviewmain" style="width: 100%; border-style: solid;border-color: #11263f;">
    <div class="card-header">
      <div class="panel-heading" style="color:#ffffff;background-color: #11263f;" title="PROJECT DOCUMENTS">
        <div class="page-titlehead">
          PROJECT DOCUMENTS
        </div>
      </div>

    </div>

    <div>
      &nbsp;

      <div class="col-md-12">
        <div class="mat-elevation-z8">
          <mat-table [dataSource]="DocsdataSource" matSort>
            <ng-container matColumnDef="DocumentName">
              <mat-header-cell *matHeaderCellDef tabindex=0 aria-label="Document Name">
                <label id="DocumentName" aria-label="Document Name">Document Name</label>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" tabindex="0" style="width: 100%;">
                <span class="mobile-label" style="min-width: 150px"><label aria-label="Document Name">Document
                    Name:</label></span>
                <div title="{{element.DocumentName}} " class="displaynormal column-overflow">{{element.DocumentName}}
                </div>
                <div title="{{element.DocumentName}} " class="displaysmall" style="display: none;">
                  {{element.DocumentName}}
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="FileName">
              <mat-header-cell *matHeaderCellDef tabindex=0 aria-label="File Name">
                <label id="FileName" aria-label="Street Name">File Name</label>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" tabindex="0" style="width: 100%;">
                <span class="mobile-label" style="min-width: 150px"><label aria-label="File Name">File Name:
                  </label></span>
                <div class="displaynormal column-overflow" title="{{element.FileName}} ">{{element.FileName}}</div>
                <div class="displaysmall" style="display: none;" title="{{element.FileName}} ">{{element.FileName}}
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="DocumentAuthor">
              <mat-header-cell *matHeaderCellDef tabindex=0 aria-label="Document Author">
                <label id="DocumentAuthor" aria-label="Document Author">Document Author</label>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" tabindex="0" style="width: 100%;">
                <span class="mobile-label" style="min-width: 150px"><label aria-label="Document Author">Document Author:
                  </label></span>
                <div class="displaynormal column-overflow" title="{{element.DocumentAuthor}} ">
                  {{element.DocumentAuthor}}
                </div>
                <div class="displaysmall" style="display: none;" title="{{element.DocumentAuthor}} ">
                  {{element.DocumentAuthor}}
                </div>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="PublicAccess">
              <mat-header-cell *matHeaderCellDef tabindex=0 aria-label="Public Access">
                <label id="PublicAccess" aria-label="Public Access">Public Access</label>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" tabindex="0" style="width: 100%;">
                <span class="mobile-label" style="min-width: 150px"><label aria-label="Public Access">Public Access:
                  </label></span>
                <div class="displaynormal column-overflow" title="{{element.PublicAccess === true ? 'Yes' : 'No'}}">
                  {{element.PublicAccess === true ? 'Yes' : 'No'}}</div>
                <div class="displaysmall" style="display: none;"
                  title="{{element.PublicAccess === true ? 'Yes' : 'No'}}">
                  {{element.PublicAccess === true ? 'Yes' : 'No'}}
                </div>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="View">
              <mat-header-cell *matHeaderCellDef> View Document</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span class="mobile-label">View Document:</span>
                <img style="cursor: pointer; color: #fff;" title="View" (click)="downloadfile(element);" tabindex="0"
                  style="background-color: #11263f;" src="../assets/images/icon_viewnewadam.png">
              </mat-cell>
            </ng-container>



            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
          <!-- <mat-paginator [pageSizeOptions]="[10,15,20]" [pageSize]="10" showFirstLastButtons></mat-paginator> -->

        </div>


      </div>

    </div>
    <div class="form-group row">
      <div class="col-md-12" style="color:crimson; text-align:center;" tabindex="0">
        <br>
        {{docmessage}}
        <br>
      </div>
    </div>
  </div>
</div>
<BR>
